export enum LocalStorage {
  TPCI_ID_YOULEND = 'tpci-id-youlend',
  TPCI_ID_NLGROEIT = 'tpci-id-nlgroeit',
  THREADSTONE_ID = 'threadstone-id',
  LEAD_SOURCE_ID = 'lead-source-id',
  CALCULATOR_INPUT_VALUES = 'calculator-input-values',
}
